import React, { useEffect, useRef, useState } from 'react'
import styles from 'css/components/update-banner.module.css'

const CHECK_INTERVAL = 5 * 60 * 1000 // 5 minutes

export const UpdateBanner: React.FC = () => {
	const [updateAvailable, setUpdateAvailable] = useState(false)
	const initialVersion = useRef<string | null>(null)

	useEffect(() => {
		const checkForUpdate = async () => {
			try {
				const res = await fetch('/version.json?t=' + Date.now())
				if (!res.ok) return
				const data = await res.json()
				const version = data.version
				if (!version) return

				if (initialVersion.current === null) {
					initialVersion.current = version
				} else if (version !== initialVersion.current) {
					setUpdateAvailable(true)
				}
			} catch {
				// Silent fail — version check is non-critical
			}
		}

		checkForUpdate()
		const interval = setInterval(checkForUpdate, CHECK_INTERVAL)
		return () => clearInterval(interval)
	}, [])

	if (!updateAvailable) return null

	return (
		<div className={styles.banner} onClick={() => window.location.reload()}>
			<span className={styles.text}>
				A new version is available.
			</span>
			<button className={styles.refreshButton}>
				Refresh
			</button>
		</div>
	)
}
